import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { NoMultiLangCompanyCreateRequest } from '../suggestion-iterfaces';
import { SuggestionsMapperService } from './suggestions-mapper.service';

export abstract class SuggestionsService<Company, Address> {
  abstract settings: {
    key: string | null;
    minLength: number | null;
  };

  protected constructor(
    protected readonly mapper: SuggestionsMapperService<Company, Address>,
    protected readonly httpClient: HttpClient,
    protected readonly key: string,
  ) {}

  abstract getCompany(id: string): Observable<NoMultiLangCompanyCreateRequest>;

  public get available(): boolean {
    return false;
  }
}
